import React from "react";

function MobileWalletAppHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Crypto Wallet Mobile App Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    At Xeer Technology, we deliver secure, scalable, and
                    user-friendly wallets for mobile platforms. Our wallet
                    solutions support a wide range of cryptocurrencies and
                    provide advanced features that meet the growing demands of
                    the crypto ecosystem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileWalletAppHero;
